export function groupBy(items = [], keyGetter) {
  const map = new Map();

  items.forEach(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map);
}

export function distinctById(items = [], keyGetter) {
  const collection = [];

  items.forEach(item => {
    const key = keyGetter(item);
    if (!collection.find(col => keyGetter(col) == key))
      collection.push(item);
  });

  return collection;
}
